import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { PopoverConfig } from 'ngx-bootstrap/popover';
import { RacesService } from './season/races/races.service';
import { RacePlan } from './season/race-plan/race-plan';
import { merge, Observable, Subscription } from 'rxjs';
import { Season } from './season/season';
import { SeasonService } from './season/season.service';
import { auditTime, switchMap, tap } from 'rxjs/operators';
import { AppService } from './app.service';
import { SettingsService } from './season/settings/settings.service';

export function getPopoverConfig(): PopoverConfig {
  return Object.assign(new PopoverConfig(), {
    placement: 'top',
    triggers: 'mouseenter:mouseleave',
    outsideClick: true
  });
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [{ provide: PopoverConfig, useFactory: getPopoverConfig }]
})
export class AppComponent implements OnInit, OnDestroy {

  readonly season$: Observable<Season> = this.seasonService.activeSeason$;
  readonly racePlans$: Observable<RacePlan[]> = this.racesService.racePlans$;

  private appLifeCycleSubscription: Subscription;
  private fixViewOnSyncPauseSubscription: Subscription;
  private remoteCommandSubscription: Subscription;

  constructor(
    private readonly appService: AppService,
    private readonly racesService: RacesService,
    private readonly seasonService: SeasonService,
    private readonly settingsService: SettingsService,
    private readonly ref: ChangeDetectorRef,
    private readonly ngZone: NgZone
  ) {
    // @TODO Add logger
    // let originalConsoleLog = console.log;
    // console.log = (...args) => {
    //   console.warn(...args);
    //   originalConsoleLog.call(window, ...args);
    // }

    this.settingsService.detectSeasonSyncedDbName();
  }

  ngOnInit() {
    moment.locale('en');

    this.appLifeCycleSubscription = merge(
      this.appService.fixViewRequest$.pipe(
        auditTime(100),
        tap((time) => {
          this.ngZone.run(() => {
            setTimeout(() => {
              this.ref.detectChanges();
            });
          });
        })
      ),

      this.seasonService.syncedStorage$.pipe(
        switchMap(({ sync$ }) => sync$),
        switchMap(({ on$ }) => on$('paused')),
        auditTime(100),
        tap((event) => {
          this.appService.fixView();
        })
      )
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.appLifeCycleSubscription) {
      this.appLifeCycleSubscription.unsubscribe();
    }
    if (this.fixViewOnSyncPauseSubscription) {
      this.fixViewOnSyncPauseSubscription.unsubscribe();
    }
    if (this.remoteCommandSubscription) {
      this.remoteCommandSubscription.unsubscribe();
    }
  }
}
